import { render, staticRenderFns } from "./RelatorioExportacaoProdutoReorg.vue?vue&type=template&id=5835cf75"
import script from "./RelatorioExportacaoProdutoReorg.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoProdutoReorg.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacaoProdutoReorg.vue?vue&type=style&index=0&id=5835cf75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports